import { QueryKey } from '@tanstack/react-query';
import { ProviderService } from '../../api';
import { DefaultQueryKeyFactory, QueryKeyFactoryGenerator } from '../../utils/query-keys-factory';

export const providerQueryKeys = new QueryKeyFactoryGenerator<
  DefaultQueryKeyFactory,
  {
    permissions: (id: string) => QueryKey;
    detailCredentialingPersonal: () => QueryKey;
    detailCredentialingEducation: () => QueryKey;
    detailCredentialingLicenses: () => QueryKey;
    detailCredentialingImmunization: () => QueryKey;
    detailCredentialingInsurance: () => QueryKey;
    detailCredentialingMisc: () => QueryKey;
    detailCredentialingProfessionalTraits: () => QueryKey;
    detailCredentialingContactAndAddress: () => QueryKey;
    detailCredentialingIdentification: () => QueryKey;
    detailCredentialingRatesAndDifferentials: () => QueryKey;
    detailCredentialingDocuments: () => QueryKey;
    currentDetail: () => QueryKey;
    limitedDetail: (id: string) => QueryKey;
    publicDetail: (id: string | undefined) => QueryKey;
    questionnaire: (id: string) => QueryKey;
    providerCurrentCredentialingAgreementTextRetrieve: () => QueryKey;
  }
>('provider', {
  permissions: (id: string): QueryKey => [...providerQueryKeys.allDetails(), 'permissions', id],
  detailCredentialingPersonal: (): QueryKey => [
    ...providerQueryKeys.allDetails(),
    'credentialingPersonal',
  ],
  detailCredentialingEducation: (): QueryKey => [
    ...providerQueryKeys.allDetails(),
    'credentialingEducation',
  ],
  detailCredentialingLicenses: (): QueryKey => [
    ...providerQueryKeys.allDetails(),
    'credentialingLicenses',
  ],
  detailCredentialingImmunization: (): QueryKey => [
    ...providerQueryKeys.allDetails(),
    'credentialingImmunization',
  ],
  detailCredentialingInsurance: (): QueryKey => [
    ...providerQueryKeys.allDetails(),
    'credentialingInsurance',
  ],
  detailCredentialingMisc: (): QueryKey => [...providerQueryKeys.allDetails(), 'credentialingMisc'],
  detailCredentialingProfessionalTraits: (): QueryKey => [
    ...providerQueryKeys.allDetails(),
    'credentialingProfessionalTraits',
  ],
  detailCredentialingContactAndAddress: (): QueryKey => [
    ...providerQueryKeys.allDetails(),
    'credentialingContactAndAddress',
  ],
  detailCredentialingIdentification: (): QueryKey => [
    ...providerQueryKeys.allDetails(),
    'credentialingIdentification',
  ],
  detailCredentialingRatesAndDifferentials: (): QueryKey => [
    ...providerQueryKeys.allDetails(),
    'credentialingRatesAndDifferentials',
  ],
  detailCredentialingDocuments: (): QueryKey => [
    ...providerQueryKeys.allDetails(),
    'credentialingDocuments',
  ],
  currentDetail: (): QueryKey => [...providerQueryKeys.allDetails(), 'current'],
  limitedDetail: (id: string): QueryKey => [...providerQueryKeys.allDetails(), 'limited', id],
  publicDetail: (id: string): QueryKey => [...providerQueryKeys.allDetails(), 'public', id],
  providerCurrentCredentialingAgreementTextRetrieve: (): QueryKey => [
    ...providerQueryKeys.allDetails(),
    'currentCredentialingAgreementText',
  ],
  questionnaire: (id: string): QueryKey => [...providerQueryKeys.allDetails(), 'questionnaire', id],
}).getDefault<typeof ProviderService.providerList>();
